import { render, staticRenderFns } from "./summary-modal.vue?vue&type=template&id=04a0e39e&scoped=true"
import script from "./summary-modal.vue?vue&type=script&lang=js"
export * from "./summary-modal.vue?vue&type=script&lang=js"
import style0 from "./summary-modal.vue?vue&type=style&index=0&id=04a0e39e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a0e39e",
  null
  
)

export default component.exports